import { useLocation } from 'react-router-dom';

// RC3.32 (D-UX-RETOUR-HISTORIQUE) : vrai quand une page precedente existe dans l'historique de la session.
// Source : le compteur `idx` que React Router pose dans history.state (0 a la premiere entree, +1 par
// push, inchange par replace). Ni `location.key` (un replace, frequent a la connexion, en cree une
// nouvelle sans ajouter de page) ni `history.length` (compte aussi les pages visitees avant l'app).
// `idx` est un detail interne de React Router : useCanGoBack.test.tsx casse si une mise a jour le retire.
// R1008C-2 : `idx` ne repart pas a 0 a la connexion (redirections en replace) ; le debut de la session
// est donc note a la connexion, sinon la fleche ramenerait dans les pages de la session precedente.
const CLE_DEBUT_HISTORIQUE = 'serme.historique.debut';

const idxCourant = (): number => window.history.state?.idx ?? 0;

/** A appeler a la connexion : la page courante devient la premiere de l'historique de la session. */
export function marquerDebutHistorique(): void {
  sessionStorage.setItem(CLE_DEBUT_HISTORIQUE, String(idxCourant()));
}

export function useCanGoBack(): boolean {
  useLocation(); // re-rendu a chaque navigation, replace compris
  return idxCourant() > Number(sessionStorage.getItem(CLE_DEBUT_HISTORIQUE) ?? 0);
}
